import TokenLogo from '@/components/ui/token-logo'
import { Address, zeroAddress } from 'viem'

export const CurrencyLogo = ({
  chainId,
  address,
  size = 32,
}: {
  chainId?: number
  address?: Address
  size?: number
}) => {
  if (address === zeroAddress) {
    return (
      <TokenLogo
        srcs={[`https://tokens.hypie.fun/assets/999/0x5555555555555555555555555555555555555555.png`]}
        alt={'token'}
        width={size}
        height={size}
      />
    )
  }

  return (
    <TokenLogo
      srcs={[
        `https://tokens.hypie.fun/assets/${chainId}/${address?.toLowerCase()}.png`,
        `https://cdn.hypie.fun/tokens/${address?.toLowerCase()}`,
      ]}
      alt={'token'}
      width={size}
      height={size}
      className={'rounded-full'}
    />
  )
}
